// extracted by mini-css-extract-plugin
module.exports = {"products":"Products-module--products--2JRED"};